import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SearchService {
  private searchSubject = new Subject<string>();
  search$ = this.searchSubject.asObservable();

  emitSearch(term: string) {
    this.searchSubject.next(term);
  }

  private moduleFilterSource = new Subject<string>();
  moduleFilter$ = this.moduleFilterSource.asObservable();

  emitModuleFilter(moduleId: string) {
    this.moduleFilterSource.next(moduleId);
  }

  private sortOrderSource = new Subject<string>();
  sortOrder$ = this.sortOrderSource.asObservable();

  emitSortOrder(order: string) {
    this.sortOrderSource.next(order);
  }
}